(function () {
  'use strict';

  const STORAGE_KEY = 'ies_compare_v1';
  const MAX_ITEMS = 4;
  const COMPARE_PATH = '/pages/compare';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function load() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function save(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }
  function add(item) {
    const items = load();
    if (items.find((i) => i.handle === item.handle)) return true;
    if (items.length >= MAX_ITEMS) {
      alert(`You can compare up to ${MAX_ITEMS} products at once.`);
      return false;
    }
    items.push(item);
    save(items);
    return true;
  }
  function remove(handle) {
    save(load().filter((i) => i.handle !== handle));
  }
  function clear() {
    save([]);
  }

  /* ---------- inject compare toggle into every product card ---------- */

  function handleFromHref(href) {
    if (!href) return null;
    const m = href.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function extractCardData(card) {
    const link = card.querySelector('a[href*="/products/"]');
    const handle = handleFromHref(link && link.getAttribute('href'));
    if (!handle) return null;
    const titleEl = card.querySelector('.card__heading a, .card__heading');
    const title = titleEl ? titleEl.textContent.trim() : '';
    const img = card.querySelector('img');
    const image = img ? (img.currentSrc || img.src) : '';
    const priceEl = card.querySelector('.price-item--sale, .price-item--last, .price-item--regular, .price-item');
    const price = priceEl ? priceEl.textContent.trim() : '';
    const url = link ? link.getAttribute('href').split('?')[0] : '';
    return { handle, id: '', title, image, price, url };
  }

  function injectToggle(card, data) {
    if (card.querySelector('.ies-compare-toggle')) return;
    const toggle = document.createElement('label');
    toggle.className = 'ies-compare-toggle';
    toggle.innerHTML =
      '<input type="checkbox" class="ies-compare-checkbox"' +
      ' data-handle="' + data.handle + '"' +
      ' data-title="' + (data.title || '').replace(/"/g, '&quot;') + '"' +
      ' data-image="' + (data.image || '') + '"' +
      ' data-price="' + (data.price || '').replace(/"/g, '&quot;') + '"' +
      ' data-url="' + (data.url || '') + '">' +
      '<span class="ies-compare-toggle__label">Compare</span>';
    /* If the card has an Add-to-cart button, wrap the two together so
       they share a single row at the bottom of the card. */
    const quickAdd = card.querySelector('.quick-add');
    if (quickAdd) {
      let actions = card.querySelector('.ies-card-actions');
      if (!actions) {
        actions = document.createElement('div');
        actions.className = 'ies-card-actions';
        quickAdd.parentNode.insertBefore(actions, quickAdd);
        actions.appendChild(quickAdd);
      }
      actions.appendChild(toggle);
    } else {
      const target = card.querySelector('.card__information') || card.querySelector('.card__content') || card;
      target.appendChild(toggle);
    }
  }

  function processCards() {
    const cards = document.querySelectorAll('.product-card-wrapper');
    cards.forEach((card) => {
      const data = extractCardData(card);
      if (data && data.handle) injectToggle(card, data);
    });
    syncCheckboxes();
  }

  /* ---------- state sync + tray rendering ---------- */

  function syncCheckboxes() {
    const items = load();
    document.querySelectorAll('.ies-compare-checkbox').forEach((cb) => {
      cb.checked = !!items.find((i) => i.handle === cb.dataset.handle);
    });
  }

  function isComparePage() {
    return window.location.pathname.replace(/\/$/, '') === COMPARE_PATH;
  }

  function renderTray() {
    const tray = document.getElementById('ies-compare-tray');
    if (!tray) return;
    // Tray is redundant on the compare page itself — hide it there.
    if (isComparePage()) {
      tray.style.display = 'none';
      return;
    }
    const items = load();
    if (items.length === 0) {
      tray.classList.remove('is-open');
      tray.setAttribute('aria-hidden', 'true');
      return;
    }
    tray.classList.add('is-open');
    tray.setAttribute('aria-hidden', 'false');
    const list = tray.querySelector('.ies-compare-tray__list');
    list.innerHTML = items
      .map((i) => {
        const safeTitle = escapeHtml(i.title || '');
        const img = i.image
          ? '<img src="' + escapeHtml(i.image) + '" alt="' + safeTitle + '">'
          : '<div class="ies-compare-tray__ph"></div>';
        const url = escapeHtml(i.url || '/products/' + i.handle);
        return (
          '<div class="ies-compare-tray__item">' +
          '<a class="ies-compare-tray__link" href="' + url + '" title="' + safeTitle + '">' +
          '<div class="ies-compare-tray__media">' + img + '</div>' +
          '<div class="ies-compare-tray__title">' + safeTitle + '</div>' +
          '</a>' +
          '<button type="button" class="ies-compare-tray__remove" data-handle="' +
          escapeHtml(i.handle) +
          '" aria-label="Remove">&times;</button>' +
          '</div>'
        );
      })
      .join('');
    const btn = tray.querySelector('.ies-compare-tray__compare');
    btn.textContent = 'Compare (' + items.length + ')';
    btn.classList.toggle('is-disabled', items.length < 2);
  }

  /* ---------- compare page rendering ---------- */

  async function fetchProduct(handle) {
    try {
      const res = await fetch('/products/' + handle + '?view=compare-data');
      if (!res.ok) return null;
      const text = await res.text();
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  async function fetchRecommendations(productId, limit) {
    try {
      const url = '/recommendations/products.json?product_id=' + productId +
        '&limit=' + (limit || 6) + '&intent=related';
      const res = await fetch(url);
      if (!res.ok) return [];
      const data = await res.json();
      return (data && data.products) || [];
    } catch (e) {
      return [];
    }
  }

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Acronym / unit overrides so keys don't title-case into "Poe", "Upc", etc.
  const KEY_LABELS = {
    poe: 'PoE',
    upc: 'UPC',
    sku: 'SKU',
    mpn: 'MPN',
    taa_compliant: 'TAA Compliant',
    weight_lbs: 'Weight (lbs)',
    screen_size_inches: 'Screen Size (in)',
  };
  function humanizeKey(key) {
    if (KEY_LABELS[key]) return KEY_LABELS[key];
    return String(key || '')
      .replace(/[_-]+/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  // Placeholder values that carry no comparison signal — a spec row is
  // dropped when EVERY product's value is one of these (or empty), so e.g.
  // "Processor Type: Other" across all networking gear never shows.
  const JUNK_VALUES = ['', 'other', 'general', 'n/a', 'na', 'none', 'null', 'undefined', '-', '—'];
  function cellText(html) {
    if (!html) return '';
    const wrap = document.createElement('div');
    wrap.innerHTML = html;
    return (wrap.textContent || '').trim();
  }
  function isJunkText(t) {
    return JUNK_VALUES.indexOf(String(t || '').trim().toLowerCase()) !== -1;
  }
  // Render a metafield's HTML for a table cell: booleans become Yes/No,
  // list values collapse to inline comma text, everything else keeps its
  // server-rendered markup (rich text, etc.).
  function cleanMetaCell(html) {
    if (!html) return '';
    const wrap = document.createElement('div');
    wrap.innerHTML = html;
    const boolSpan = wrap.querySelector('.metafield-boolean');
    if (boolSpan) {
      const t = boolSpan.textContent.trim().toLowerCase();
      if (t === 'true') return 'Yes';
      if (t === 'false') return 'No';
    }
    const list = wrap.querySelector('ul, ol');
    if (list) {
      const items = Array.prototype.map
        .call(list.querySelectorAll('li'), (li) => li.textContent.trim())
        .filter(Boolean);
      if (items.length) return escapeHtml(items.join(', '));
    }
    return html;
  }

  /* Parse a rich-text-rendered HTML blob into individual feature pairs.
     Merchants author specs as `<p><strong>Label:</strong> value</p>` so
     we split each paragraph (and list item) into a {key, value} pair. */
  function parseFeatures(html) {
    if (!html) return [];
    const wrap = document.createElement('div');
    wrap.innerHTML = html;
    const features = [];
    wrap.querySelectorAll('p, li').forEach((el) => {
      const strong = el.querySelector('strong, b');
      if (!strong) return;
      let label = strong.textContent.trim().replace(/[:：]\s*$/, '');
      if (!label) return;
      const clone = el.cloneNode(true);
      const cstrong = clone.querySelector('strong, b');
      if (cstrong) cstrong.remove();
      const value = clone.textContent.trim().replace(/^[:：\s]+/, '');
      if (!value) return;
      features.push({ key: label, value: value });
    });
    return features;
  }

  /* ---------- add-to-cart from compare cards ---------- */

  async function refreshCartCount() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      // The count bubble is replaced wholesale by Dawn's section-render
      // pipeline, but we can update the visible number for immediate feedback.
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const num = bubble.querySelector('span[aria-hidden]') || bubble.querySelector('span');
        if (num) num.textContent = cart.item_count;
        bubble.classList.toggle('hidden', cart.item_count === 0);
        if (cart.item_count > 0) bubble.style.display = '';
      });
    } catch (e) {}
  }

  async function handleAddToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || variantId === 'null') {
      console.error('compare add-to-cart: missing variant id on button', btn);
      return;
    }
    if (btn.dataset.adding === '1') return;
    btn.dataset.adding = '1';
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    const cartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    // If Dawn's cart drawer is on the page, ask Shopify to render its
    // sections back in the same response so we can update the drawer
    // contents without a second round-trip.
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        const sectionIds = cartDrawer.getSectionsToRender().map((s) => s.id).filter(Boolean);
        if (sectionIds.length) {
          formData.append('sections', sectionIds.join(','));
          formData.append('sections_url', window.location.pathname);
        }
      } catch (e) {}
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.description || data.message || ('HTTP ' + res.status));
      }
      btn.textContent = 'Added ✓';
      btn.classList.add('is-added');

      // Update Dawn cart drawer with returned section HTML, or fall back
      // to manually refreshing the cart count bubble.
      if (data.sections && cartDrawer && typeof cartDrawer.renderContents === 'function') {
        try { cartDrawer.renderContents(data); } catch (err) {
          console.error('compare: cart drawer render failed', err);
        }
      } else {
        await refreshCartCount();
      }
      // Dawn's renderContents only strips `is-empty` from .drawer__inner,
      // but this theme also puts `is-empty` on the <cart-drawer> wrapper
      // (snippets/cart-drawer.liquid:20). If the cart now has items, the
      // wrapper class needs to come off too or the drawer reads as empty.
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        const inner = cartDrawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
      }
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        try { cartDrawer.open(); } catch (e) {}
      }

      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
        btn.classList.remove('is-added');
        btn.dataset.adding = '0';
      }, 1800);
    } catch (e) {
      console.error('compare add-to-cart error:', e);
      btn.textContent = 'Try again';
      btn.classList.add('is-error');
      btn.title = (e && e.message) || 'Could not add to cart';
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
        btn.classList.remove('is-error');
        btn.removeAttribute('title');
        btn.dataset.adding = '0';
      }, 2500);
    }
  }

  async function renderComparePage() {
    const root = document.getElementById('ies-compare-root');
    if (!root) return;
    const items = load();
    if (items.length === 0) {
      root.innerHTML =
        '<div class="ies-compare-empty">' +
        '<p>No products selected to compare.</p>' +
        '<p><a href="/collections/all" class="button">Browse products</a></p>' +
        '</div>';
      return;
    }
    root.innerHTML = '<div class="ies-compare-loading">Loading…</div>';
    const products = await Promise.all(items.map((i) => fetchProduct(i.handle)));
    const valid = products.filter(Boolean);
    if (valid.length === 0) {
      root.innerHTML = '<div class="ies-compare-empty"><p>Could not load the selected products.</p></div>';
      return;
    }

    /* ---------- head row with cards + add-to-cart ---------- */
    const cardCols = valid
      .map((p) => {
        const img = p.featured_image
          ? '<img src="' + escapeHtml(p.featured_image) + '" alt="">'
          : '';
        const compareAt =
          p.compare_at_price && p.compare_at_price > p.price
            ? '<span class="ies-compare-card__compare-at">' + moneyFormat(p.compare_at_price) + '</span>'
            : '';
        let cta;
        if (!p.available) {
          cta = '<button type="button" class="ies-compare-card__add is-unavailable" disabled>Out of stock</button>';
        } else if (p.has_only_default_variant && p.first_variant_id) {
          cta =
            '<button type="button" class="ies-compare-card__add" data-variant-id="' +
            p.first_variant_id +
            '">Add to cart</button>';
        } else {
          cta =
            '<a class="ies-compare-card__add ies-compare-card__add--link" href="' +
            escapeHtml(p.url) +
            '">View options</a>';
        }
        return (
          '<div class="ies-compare-col">' +
          '<div class="ies-compare-card">' +
          '<a href="' + escapeHtml(p.url) + '" class="ies-compare-card__media">' + img + '</a>' +
          '<a href="' + escapeHtml(p.url) + '" class="ies-compare-card__title">' + escapeHtml(p.title) + '</a>' +
          '<div class="ies-compare-card__price-row">' +
          '<span class="ies-compare-card__price">' + moneyFormat(p.price) + '</span>' +
          compareAt +
          '</div>' +
          cta +
          '<button type="button" class="ies-compare-card__remove ies-compare-remove-from-page" data-handle="' +
          escapeHtml(p.handle) + '">Remove</button>' +
          '</div>' +
          '</div>'
        );
      })
      .join('');

    /* ---------- standard rows ---------- */
    function row(label, cells, opts) {
      const cls = (opts && opts.cls) || '';
      return (
        '<div class="ies-compare-row ' + cls + '">' +
        '<div class="ies-compare-row__label">' + escapeHtml(label) + '</div>' +
        cells
          .map((c) => '<div class="ies-compare-row__cell">' + (c ? c : '—') + '</div>')
          .join('') +
        '</div>'
      );
    }

    const stdRows =
      row('Brand', valid.map((p) => escapeHtml(p.vendor))) +
      row('Type', valid.map((p) => escapeHtml(p.type))) +
      row('Price', valid.map((p) => moneyFormat(p.price))) +
      row(
        'Availability',
        valid.map((p) =>
          p.available
            ? '<span class="ies-compare-stock ies-compare-stock--in">In stock</span>'
            : '<span class="ies-compare-stock ies-compare-stock--out">Out of stock</span>'
        )
      ) +
      row('SKU', valid.map((p) => escapeHtml(p.first_variant_sku || '')));

    /* ---------- metafield rows ---------- */
    // Keys to hide from the comparison (duplicates of other rows, or
    // categorical fields not useful for comparison)
    // Hard-excluded keys: tech_specs (raw dup of technical_specification),
    // use_case (vague), brand (duplicates the standard Brand/vendor row),
    // and the *_ref reference fields that can't render (also stripped by the
    // compare-data template's Liquid-error guard — excluded here as a backstop).
    const META_EXCLUDE = ['tech_specs', 'use_case', 'brand', 'brand_ref', 'product_line_ref'];
    // Keys whose rich_text content is parsed into individual feature rows
    // (one row per <strong>Label:</strong> value pair in the source HTML)
    const FEATURE_BREAKOUT_KEYS = ['technical_specification'];

    const standardKeys = [];
    const seenStdKeys = {};
    const featureCellsByKey = {};
    const featureKeyOrder = [];

    valid.forEach((p, prodIdx) => {
      (p.metafields || []).forEach((m) => {
        if (!m || !m.key) return;
        if (META_EXCLUDE.indexOf(m.key) !== -1) return;

        if (FEATURE_BREAKOUT_KEYS.indexOf(m.key) !== -1) {
          // Break this metafield apart into one row per feature.
          // Skip features that duplicate standard rows (e.g. Brand → Vendor).
          const FEATURE_SKIP = ['brand', 'vendor', 'manufacturer', 'product', 'model', 'part number', 'mpn', 'sku'];
          const features = parseFeatures(m.html);
          features.forEach((f) => {
            if (FEATURE_SKIP.indexOf(f.key.toLowerCase()) !== -1) return;
            if (!featureCellsByKey[f.key]) {
              featureCellsByKey[f.key] = new Array(valid.length).fill('');
              featureKeyOrder.push(f.key);
            }
            featureCellsByKey[f.key][prodIdx] = f.value;
          });
        } else if (!seenStdKeys[m.key]) {
          seenStdKeys[m.key] = true;
          standardKeys.push(m.key);
        }
      });
    });

    const featureRows = featureKeyOrder
      .map((key) => {
        const raw = featureCellsByKey[key];
        if (raw.every((v) => isJunkText(v))) return '';
        const cells = raw.map((v) => escapeHtml(v || ''));
        return row(key, cells);
      })
      .filter(Boolean)
      .join('');

    const stdMetaRows = standardKeys
      .map((key) => {
        const rawCells = valid.map((p) => {
          const m = (p.metafields || []).find((x) => x.key === key);
          // m.html is server-rendered via Liquid's metafield_tag — safe to
          // render as HTML (originates from the merchant's own metafields).
          return m && m.html ? m.html : '';
        });
        // Drop the row entirely when no product has a meaningful value.
        if (rawCells.every((c) => isJunkText(cellText(c)))) return '';
        const cells = rawCells.map((c) => cleanMetaCell(c));
        return row(humanizeKey(key), cells, { cls: 'ies-compare-row--meta' });
      })
      .filter(Boolean)
      .join('');

    const metaSection = (featureRows || stdMetaRows)
      ? '<div class="ies-compare-row ies-compare-row--section"><div class="ies-compare-row__section-title">Specifications</div></div>' +
        featureRows + stdMetaRows
      : '';

    root.innerHTML =
      '<div class="ies-compare-layout">' +
        '<div class="ies-compare-layout__main">' +
          '<div class="ies-compare-grid" style="--cols:' + valid.length + '">' +
            '<div class="ies-compare-row ies-compare-row--head">' +
              '<div class="ies-compare-row__label"></div>' +
              cardCols +
            '</div>' +
            stdRows +
            metaSection +
          '</div>' +
        '</div>' +
        '<aside class="ies-compare-layout__aside">' +
          '<div id="ies-compare-recs" class="ies-compare-recs"></div>' +
        '</aside>' +
      '</div>';

    /* ---------- recommendations from the first product ---------- */
    renderRecommendations(valid[0]);
  }

  async function renderRecommendations(seed) {
    const host = document.getElementById('ies-compare-recs');
    if (!host || !seed || !seed.id) return;
    const recs = await fetchRecommendations(seed.id, 8);
    // Filter out anything the user is already comparing
    const compared = {};
    load().forEach((i) => (compared[i.handle] = true));
    const filtered = recs.filter((r) => !compared[r.handle]).slice(0, 6);
    if (filtered.length === 0) {
      host.innerHTML = '';
      return;
    }
    const cards = filtered
      .map((r) => {
        const img = r.featured_image
          ? '<img src="' + escapeHtml(r.featured_image) + '" alt="">'
          : '';
        const safeTitle = escapeHtml(r.title);
        const safeHandle = escapeHtml(r.handle);
        const safeUrl = escapeHtml(r.url);
        return (
          '<div class="ies-compare-rec">' +
            '<a class="ies-compare-rec__media" href="' + safeUrl + '">' + img + '</a>' +
            '<div class="ies-compare-rec__body">' +
              '<a class="ies-compare-rec__title" href="' + safeUrl + '">' + safeTitle + '</a>' +
              '<div class="ies-compare-rec__price">' + moneyFormat(r.price) + '</div>' +
              '<label class="ies-compare-rec__compare">' +
                '<input type="checkbox" class="ies-compare-checkbox"' +
                ' data-handle="' + safeHandle + '"' +
                ' data-title="' + safeTitle + '"' +
                ' data-image="' + escapeHtml(r.featured_image || '') + '"' +
                ' data-price="' + moneyFormat(r.price) + '"' +
                ' data-url="' + safeUrl + '">' +
                '<span>Add to compare</span>' +
              '</label>' +
            '</div>' +
          '</div>'
        );
      })
      .join('');
    host.innerHTML =
      '<button type="button" class="ies-compare-recs__toggle" aria-expanded="true">' +
        '<span class="ies-compare-recs__toggle-label">Hide suggestions</span>' +
        '<svg class="ies-compare-recs__chevron" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">' +
          '<path d="M3.5 5.25 7 8.75l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</button>' +
      '<div class="ies-compare-recs__body">' +
        '<p class="ies-compare-recs__sub">Similar to “' + escapeHtml(seed.title) + '”.</p>' +
        '<div class="ies-compare-recs__grid">' + cards + '</div>' +
      '</div>';
  }

  /* ---------- event delegation ---------- */

  document.addEventListener('change', function (e) {
    const cb = e.target.closest('.ies-compare-checkbox');
    if (!cb) return;
    if (cb.checked) {
      const data = {
        handle: cb.dataset.handle,
        id: cb.dataset.id || '',
        title: cb.dataset.title || '',
        image: cb.dataset.image || '',
        price: cb.dataset.price || '',
        url: cb.dataset.url || '/products/' + cb.dataset.handle,
      };
      if (!add(data)) {
        cb.checked = false;
        return;
      }
    } else {
      remove(cb.dataset.handle);
    }
    renderTray();
    // If we're on the compare page, re-render so newly checked products
    // (e.g. from the sidebar recommendations) appear in the table.
    if (document.getElementById('ies-compare-root')) renderComparePage();
  });

  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('.ies-compare-card__add');
    if (addBtn && addBtn.tagName === 'BUTTON' && !addBtn.disabled) {
      e.preventDefault();
      handleAddToCart(addBtn);
      return;
    }
    const removeBtn = e.target.closest('.ies-compare-tray__remove, .ies-compare-remove-from-page');
    if (removeBtn) {
      remove(removeBtn.dataset.handle);
      syncCheckboxes();
      renderTray();
      if (document.getElementById('ies-compare-root')) renderComparePage();
      return;
    }
    const clearBtn = e.target.closest('.ies-compare-tray__clear');
    if (clearBtn) {
      clear();
      syncCheckboxes();
      renderTray();
      if (document.getElementById('ies-compare-root')) renderComparePage();
      return;
    }
    const compareBtn = e.target.closest('.ies-compare-tray__compare');
    if (compareBtn && !compareBtn.classList.contains('is-disabled')) {
      window.location.href = COMPARE_PATH;
      return;
    }
    const recsToggle = e.target.closest('.ies-compare-recs__toggle');
    if (recsToggle) {
      const host = recsToggle.closest('.ies-compare-recs');
      const expanded = recsToggle.getAttribute('aria-expanded') !== 'false';
      const next = !expanded;
      recsToggle.setAttribute('aria-expanded', String(next));
      host.classList.toggle('is-collapsed', !next);
      const lbl = recsToggle.querySelector('.ies-compare-recs__toggle-label');
      if (lbl) lbl.textContent = next ? 'Hide suggestions' : 'Show suggestions';
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    processCards();
    renderTray();
    if (document.getElementById('ies-compare-root')) renderComparePage();

    // Re-process cards when the product grid is re-rendered by the
    // facets / sort / pagination Ajax (Dawn replaces #product-grid
    // children on filter changes, which strips our injected toggles).
    const gridTargets = document.querySelectorAll(
      '#product-grid, #ProductGridContainer, .product-grid'
    );
    if (gridTargets.length === 0) return;
    let scheduled = false;
    const observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        processCards();
        renderTray();
        scheduled = false;
      });
    });
    gridTargets.forEach(function (target) {
      observer.observe(target, { childList: true, subtree: true });
    });
  });
})();
